{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "competitors",
  "x-cli-editable": true,
  "x-feature": false,
  "title": "Competitors",
  "description": "List your competitors so the agent recognizes them as competitors when a visitor mentions one (instead of treating the name as random). Leave it empty and the agent stays neutral. Choose below how it answers once a competitor is named.",
  "type": "object",
  "properties": {
    "names": {
      "type": "array",
      "ui:title": "Known competitors",
      "ui:widget": "tags-input",
      "ui:placeholder": "Add competitor name",
      "ui:description": "Canonical competitor names the agent recognizes. The agent uses these exact spellings when it speaks about each competitor. Type or paste a comma-separated list (for example: Stripe Billing, Exact Online, Sage Intacct) — entries split on commas. Leave empty to keep the generic defer behavior.",
      "uniqueItems": true,
      "maxItems": 50,
      "default": [],
      "items": {
        "type": "string",
        "minLength": 1,
        "maxLength": 80
      }
    },
    "profiles": {
      "type": "object",
      "ui:title": "Competitor profiles",
      "ui:description": "What you know about each competitor, keyed by its name in Known competitors. A profile whose name is not in that list is ignored.",
      "x-access": "staff",
      "default": {},
      "additionalProperties": {
        "type": "object",
        "properties": {
          "domain": {
            "type": "string",
            "maxLength": 253,
            "ui:title": "Website",
            "ui:description": "The competitor's website domain, for example intercom.com."
          },
          "relation": {
            "type": "string",
            "enum": ["alternative", "replaced"],
            "default": "alternative",
            "ui:title": "Relation",
            "ui:description": "Alternative: buyers compare you head to head. Replaced: buyers switch from it to you."
          },
          "summary": {
            "type": "string",
            "maxLength": 600,
            "ui:widget": "textarea",
            "ui:title": "What they do",
            "ui:description": "One or two sentences on what the competitor sells and to whom."
          },
          "positioning": {
            "type": "string",
            "maxLength": 1500,
            "ui:widget": "textarea",
            "ui:title": "How you compare",
            "ui:description": "Where you win and where they win. Example: we qualify visitors in the conversation; they focus on support tickets."
          },
          "sources": {
            "type": "array",
            "maxItems": 10,
            "default": [],
            "ui:title": "Sources",
            "ui:description": "Pages that back up the summary and the comparison, such as a comparison page or a case study.",
            "items": {
              "type": "string",
              "format": "uri",
              "maxLength": 2048
            }
          }
        }
      }
    },
    "battlecard_mode": {
      "type": "boolean",
      "ui:title": "Assertive comparisons",
      "ui:tooltip": "Switches competitor answers from a neutral defer to an assertive, sales-rep voice grounded in your knowledge base.",
      "ui:description": "On by default. The agent answers competitor questions in an assertive, sales-rep voice, grounded in whatever your knowledge base holds on that competitor — battlecards, comparison pages, sales notes. When it finds nothing on the competitor it defers instead of guessing. Turn this off to always stay neutral and defer to the competitor on their own product.",
      "default": true
    }
  },
  "default": {
    "names": [],
    "profiles": {},
    "battlecard_mode": true
  }
}
